import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import {
  mergeFeatureComparisonTranslatedTexts,
  normalizeFeatureComparisonConfig,
  resolvePlanPrice,
} from '../feature-comparison.helpers';
import {
  FeatureComparisonBillingMode,
  FeatureComparisonSimpleConfig,
  FeatureComparisonSimpleFeature,
  FeatureComparisonSimplePlan,
  FeatureComparisonTranslatedContent,
} from '../feature-comparison.types';

@Component({
  selector: 'app-feature-comparison-renderer',
  templateUrl: './feature-comparison-renderer.component.html',
  styleUrls: ['./feature-comparison-renderer.component.scss'],
})
export class FeatureComparisonRendererComponent implements OnChanges {
  @Input() config!: FeatureComparisonSimpleConfig;
  @Input() translatedContent?: FeatureComparisonTranslatedContent | null = null;
  @Input() language: 'es' | 'en' = 'es';

  normalizedConfig!: FeatureComparisonSimpleConfig;
  activeBillingMode: FeatureComparisonBillingMode = 'monthly';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['config'] || changes['translatedContent'] || changes['language']) {
      const baseConfig = normalizeFeatureComparisonConfig(this.config);
      this.normalizedConfig = this.language === 'en' && this.translatedContent
        ? mergeFeatureComparisonTranslatedTexts(baseConfig, this.translatedContent)
        : baseConfig;
      this.activeBillingMode = this.normalizedConfig.billing.defaultMode;
    }
  }

  get plans(): FeatureComparisonSimplePlan[] {
    return this.normalizedConfig?.plans || [];
  }

  get features(): FeatureComparisonSimpleFeature[] {
    return this.normalizedConfig?.features || [];
  }

  getPlanPriceLabel(plan: FeatureComparisonSimplePlan): string {
    const resolvedPrice = resolvePlanPrice(plan, this.normalizedConfig.billing, this.activeBillingMode);
    if (!resolvedPrice) {
      return '';
    }

    const currency = plan.currency || '';
    const suffix = plan.priceSuffix ? ` ${plan.priceSuffix}` : '';
    const spacedPrice = currency ? `${currency} ${resolvedPrice}` : resolvedPrice;
    return `${spacedPrice}${suffix}`.trim();
  }

  isFeatureIncluded(feature: FeatureComparisonSimpleFeature, planId: string): boolean {
    return feature.includedByPlanId?.[planId] === true;
  }

  get showBillingToggle(): boolean {
    return this.normalizedConfig?.billing?.priceDisplayMode === 'toggle';
  }

  getPlanRedirectLabel(plan: FeatureComparisonSimplePlan): string {
    if (plan.redirectLabel) {
      return plan.redirectLabel;
    }

    return plan.redirectUrl ? 'Seleccionar' : '';
  }

  trackById(_: number, item: { id: string }): string {
    return item.id;
  }
}
